import { formatDateForInput } from '@/lib/utils';

const START_TIME_OFFSET_MINUTES = 5;

// Suggested simulation start: a few minutes after the last container entered the yard snapshot.
export const suggestStartTimeFromYard = (
  lastTimeIn: string | null | undefined
): string | undefined => {
  if (!lastTimeIn) return undefined;
  const lastTimeInMs = new Date(lastTimeIn).getTime();
  if (Number.isNaN(lastTimeInMs)) return undefined;
  return formatDateForInput(
    new Date(lastTimeInMs + START_TIME_OFFSET_MINUTES * 60_000).toISOString()
  );
};

/** Id of the most recently uploaded item, or `undefined` for an empty list. */
export const getLatestUploadId = (
  items: ReadonlyArray<{ id?: string | null; upload_timestamp?: string | null }>
): string | undefined =>
  items
    .filter((item) => !!item.id && !!item.upload_timestamp)
    .toSorted(
      (first, second) =>
        Date.parse(second.upload_timestamp ?? '') -
        Date.parse(first.upload_timestamp ?? '')
    )
    .at(0)?.id ?? undefined;
